export default __webpack_public_path__ + "static/media/execute_questionTypeAnalysis.3e2c6c86.png";